import { createSelector } from 'reselect';
import { ActionsUnion, createAction } from './helper';

/*
 * Redux Action actionTypes
 */

export const SET_USER_ID = 'account/SET_USER_ID';
export const SET_ACCOUNT_ID = 'account/SET_ACCOUNT_ID';
export const SET_ADMIN_ID = 'account/SET_ADMIN_ID';
export const SET_IS_LOGGED_IN = 'account/SET_IS_LOGGED_IN';
export const CLEAR_ACCOUNT = 'account/CLEAR';

/*
 * Redux Actions
 */

export const Actions = {
  setUserId: (userId: string) => createAction(SET_USER_ID, userId),
  setAccountId: (accountId: string) => createAction(SET_ACCOUNT_ID, accountId),
  setAdminId: (adminId: string) => createAction(SET_ADMIN_ID, adminId),
  setIsLoggedIn: (isLoggedIn: boolean) =>
    createAction(SET_IS_LOGGED_IN, isLoggedIn),
  clear: () => createAction(CLEAR_ACCOUNT),
};
export type Actions = ActionsUnion<typeof Actions>;

/*
 * Selectors
 */
export const getAccountInfo = (state: any): AccountState => state.account;

export const getAdminId = createSelector(
  [getAccountInfo],
  account => account.adminId,
);

export const isAccountLoggedIn = createSelector(
  [getAccountInfo],
  account => account.isLoggedIn,
);

/*
 * Reducer
 */

export interface AccountState {
  readonly userId?: string;
  readonly accountId?: string;
  readonly adminId?: string;
  readonly isLoggedIn?: boolean;
}

const initState: AccountState = {
  userId: '',
  accountId: '',
  adminId: '',
  isLoggedIn: false,
};

export default function reducer(state = initState, action: Actions) {
  if (!action) return state;

  switch (action.type) {
    case SET_USER_ID: {
      return { ...state, userId: action.payload };
    }
    case SET_ACCOUNT_ID: {
      return { ...state, accountId: action.payload };
    }
    case SET_ADMIN_ID: {
      return { ...state, adminId: action.payload };
    }
    case SET_IS_LOGGED_IN: {
      return { ...state, isLoggedIn: action.payload };
    }
    case CLEAR_ACCOUNT: {
      return initState;
    }
    default:
      return state;
  }
}
